import { BootstrapperCommand } from '../dependencies/bootstrapperCommand';

export class FixPromises implements BootstrapperCommand {
  public async execute(): Promise<void> {
    (<any>Promise).config({
      longStackTraces: false
    });
  }
}